import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

import type { IFailureCauseCategoriesKeys } from '../model/failureCauseCategories';

const saveFailureCauseCategoriesInfoFn = ({
  locationIds,
  sorting,
  statusType,
  dateFrom,
  dateTo,
}: IFailureCauseCategoriesKeys) => {
  const orderBy = sorting.id ? sorting.id : undefined;
  const direction = !sorting.id ? undefined : sorting.desc ? 'desc' : 'asc';

  const params = {
    location_ids: locationIds,
    sort: {
      field: orderBy,
      direction: direction,
    },
    status_type: statusType === 'all' ? undefined : statusType,
    date_from: dateFrom,
    date_to: dateTo,
  };
  return apiClient.get(`${APP_API_URL_V2}fsd/action-item/failure-cause-categories/export`, {
    params: params,
    responseType: 'arraybuffer',
  });
};

export const useSaveFailureCauseCategoriesInfoMutation = () => {
  return useMutation({
    mutationFn: saveFailureCauseCategoriesInfoFn,
  });
};
